import React from "react";
import styled from "@emotion/styled";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import SmallButtonSpinner from "@components/SmallButtonSpinner";
import { FaSearch } from "react-icons/fa";

const ButtonDiv = styled.div`
  border: solid 2px rgba(31, 32, 33, 0.1);
  border-left: none;
  border-radius: 0px 30px 30px 0px;
  width: 108px;
  display: flex;
  align-items: center;
  z-index: 2;

  @media (max-width: 999px) {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const NavSearchButtonDiv = ({ loading, selectedMerchant, handleSearch }) => {
  return (
    <ButtonDiv>
      <DefaultOrangeButton
        handleClick={(disabled, e) => {
          e.stopPropagation();
          if (!disabled && !loading) handleSearch();
        }}
        disabled={!selectedMerchant}
        classes={"main-default-orange-button"}
        ariaLabel="Search"
      >
        {loading ? (
          <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
        ) : (
          <>
            <span>Search</span>
            <FaSearch />
          </>
        )}
      </DefaultOrangeButton>
    </ButtonDiv>
  );
};

export default NavSearchButtonDiv;
